import { isArray } from "util";
import { fetch as fetchAuth } from 'redux-simple-auth';
import store from '../config/store';

export function getNormalizedList(url, params) {

  let queryString = buildQueryString(params);

  return fetch(`${url}?${queryString}`)
    .then(resp => resp.json())
    .then(resp => normalize(resp.data));
}

export function normalize(json) {

  const source = isArray(json) ? json : [json];
  const dest = [];

  source.forEach((item) => {
    dest.push({
      id: item.id,
      name: item.attributes.name
    });
  });

  return dest;
}

export function buildQueryString(params = {}) {

  const paramsArray = Object.keys(params).reduce((result, key) => {

    const objValue = params[key];
    const isValidArray = Array.isArray(objValue);

    if (isValidArray && objValue.length > 0) {
      result.push(objValue.map((entry) => {
        return encodeQueryParameter(key, entry);
      }).join('&'));

      return result;
    }

    if (key === "page") {
      result.push(Object.keys(objValue).map((property) => {
        const keyName = `${key}[${property}]`;
        return encodeQueryParameter(keyName, objValue[property]);
      }).join('&'));

      return result;
    }

    if (objValue && !isValidArray) {
      result.push(encodeQueryParameter(key, objValue));
    }

    return result;
  }, []);

  return paramsArray.join('&');
}

export function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export function handleResponse(response) {

  if (response.status === 204 || response.status === 205) {
    return null;
  }

  return response.json()
    .then(jsonBody => {
      if (!response.ok) {
        const error = Object.assign({}, jsonBody, {
          status: response.status,
          detail: response.detail,
        });

        return Promise.reject(error);
      }
      return jsonBody;
    });
}

export function fetch(url, options) {
  return store.dispatch(fetchAuth(url, options));
}

export function encodeQueryParameter(name, value) {
  return `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
}



// WEBPACK FOOTER //
// ./src/utils/apiUtils.js